import { lazy, Suspense } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import FormStepModal from '../FormStepModal';

const UploadContents = lazy(
  () => import('#client/components/UploadDocumentsModal/components/UploadContents')
);

export default function AwaitingUploadDocumentsModal({ handleClose, handleBack }) {
  return (
    <FormStepModal
      handleBack={handleBack} // Only close upload modal
      handleClose={handleClose}
      title="Open a business bank account"
    >
      <Stack
        height="100%"
        mt="40px"
      >
        <Suspense fallback={null}>
          <UploadContents handleClose={handleClose} />
        </Suspense>
      </Stack>
    </FormStepModal>
  );
}

AwaitingUploadDocumentsModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired
};
